import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * NotFound page - displays when user navigates to a non-existent route
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#000000] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <span className="text-8xl font-bold text-[#CCAD60]">404</span>
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-4">
          Page Not Found
        </h1>
        
        <p className="text-zinc-400 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        
        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => window.history.back()}
            variant="outline"
            className="border-white/20 text-white hover:bg-white/10"
          >
            <ArrowLeft size={16} className="mr-2" />
            Go Back
          </Button>
          <Link to="/">
            <Button className="bg-[#CCAD60] text-black hover:bg-[#CCAD60]/90">
              <Home size={16} className="mr-2" />
              Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
